import {Controller} from "stimulus"
import GoogleMap from "../utils/GoogleMap"

export default class extends Controller {

    static targets = [
        "map"
    ]

    initialize() {
        this._googlMap = undefined
        this.initGoogleMap()
    }

    get options() {
        return {
            icon: this.pinImage,
            iconHeight: this.pinHeight,
            iconWidth: this.pinWidth,
            makeCenterMarker: true,
            withCustomStyle: true,
            mapDiv: this.mapTarget,
            centerPosition: {
                lat: this.lat,
                lng: this.lng
            },
        }
    }

    get googleMapOptions() {
        return {
            zoom: this.zoom,

        }
    }

    initGoogleMap() {
        this._googleMap = new GoogleMap(this.id, this.options, this.googleMapOptions)
    }

    get id() {
        const id = this.data.get("id")
        return id ? id : ""
    }

    get googleMap() {
        return this._googleMap
    }

    get zoom() {
        const zoom = this.data.get("zoom")
        return zoom ? parseInt(zoom) : 10
    }

    get lat() {
        const lat = this.data.get("lat")
        return lat ? parseFloat(lat) : 0
    }

    get lng() {
        const lng = this.data.get("lng")
        return lng ? parseFloat(lng) : 0
    }

    get pinImage() {
        const pin = this.data.get("pin-image")
        return pin ? pin : undefined
    }

    get pinHeight() {
        const val = this.data.get("pin-height")
        return val ? val : 100
    }

    get pinWidth() {
        const val = this.data.get("pin-width")
        return val ? val : 100
    }


}